import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Vehicule} from "./Vehicule";

// Constructor
export class GameABike extends Vehicule {

  constructor(id, index, game, startsHidden) {
    super(id, index, game);

    this.type = "bikes";

    this.speed = 3;
    this.bicycleMovingSpeed = -4;
    this.currentSpeed = this.speed;
    this.targetSpeed = this.speed;

    this.floatingRange = 2;
    this.scalingRange = {min: 2, max: 2}; // not working as expected so leave as same value for both

    this.rightLimit = this.game.appWidth + 150;
    this.leftLimit = -150;

    this.posYRange = {min: 280, max: 330}; // from bottom

    this.spawn(startsHidden);
  }

  getRandomTexture(){
    return "bicycle-" + window.getRandomInt(1, 6);
  }

}
